import * as Sentry from '@sentry/vue';

function timeStep(transaction, description, action) {
  const span = transaction.startChild({
    op: 'firebase.' + description,
    description: description,
  });

  return action().then((value) => {
    span.setStatus('ok');
    span.finish();
    return value;
  }, (error) => {
    span.setStatus('unknown_error');
    span.finish();
    throw error;
  });
}

// Sends only operation names, durations, and success/failure to Sentry.
// Callable payloads, participant data, result ids, and result tokens stay
// out of the tracing data entirely.
function timeCallable(name, waitForAuth, call) {
  const transaction = Sentry.startTransaction({
    name: 'callable.' + name,
    op: 'firebase.callable',
  });
  const authenticate = waitForAuth
    ? timeStep(transaction, 'auth.ready', waitForAuth)
    : Promise.resolve();

  return authenticate.then(() => timeStep(transaction, 'callable.request', call)).then((value) => {
    transaction.setStatus('ok');
    transaction.setTag('outcome', 'success');
    transaction.finish();
    return value;
  }, (error) => {
    transaction.setStatus('unknown_error');
    transaction.setTag('outcome', 'failure');
    transaction.finish();
    throw error;
  });
}

export { timeCallable };



// WEBPACK FOOTER //
// ./src/components/callableTiming.js